import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createSubagentApi,
  deleteSubagentApi,
  getSubagentApi,
  listSubagentsApi,
  updateSubagentApi,
  type CreateSubagentInput,
  type ListSubagentsParams,
  type UpdateSubagentInput,
} from './api';

export function useSubagentsList(params: ListSubagentsParams) {
  return useQuery({
    queryKey: ['subagents', params],
    queryFn: () => listSubagentsApi(params),
  });
}

export function useSubagent(id: string | undefined) {
  return useQuery({
    queryKey: ['subagent', id],
    queryFn: () => getSubagentApi(id!),
    enabled: !!id,
  });
}

export function useCreateSubagent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSubagentInput) => createSubagentApi(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['subagents'] });
    },
  });
}

export function useUpdateSubagent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateSubagentInput) => updateSubagentApi(input),
    onSuccess: (data) => {
      void qc.invalidateQueries({ queryKey: ['subagents'] });
      qc.setQueryData(['subagent', data.id], data);
    },
  });
}

export function useDeleteSubagent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteSubagentApi(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['subagents'] });
    },
  });
}
